export const paperworkTypes = {
  changeOwner: 1,
  registration: 2
}
